module.exports = __webpack_public_path__ + "static/media/mission.2df1606.mid";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mission.mid
// module id = vuQE
// module chunks = 0